import React, { type ReactNode } from 'react';

import type { TWFontSizeProp } from '../../types/tailwind';

export type ErrorTextProps<FontSizeProp> = {
  children: ReactNode;
  fontSize?: TWFontSizeProp<FontSizeProp>;
};

export const ErrorText = <FontSizeProp,>({
  fontSize,
  children,
}: ErrorTextProps<FontSizeProp>) => (
  <span className={fontSize}>
    <span className="text-orange">!</span>
    &nbsp;{children}
  </span>
);
